"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  popoverContent: {
    position: 'absolute',
    zIndex: '1001; // Just hardcoded value to above level of modal',
    '&.bindingAnchor_left_top': {
      top: '0',
      left: '0'
    },
    '&.bindingAnchor_center_top': {
      top: '0',
      left: '50%'
    },
    '&.bindingAnchor_right_top': {
      top: '0',
      left: '100%'
    },
    '&.bindingAnchor_left_center': {
      top: '50%',
      left: '0'
    },
    '&.bindingAnchor_right_center': {
      top: '50%',
      left: '100%'
    },
    '&.bindingAnchor_left_bottom': {
      top: '100%',
      left: '0'
    },
    '&.bindingAnchor_center_bottom': {
      top: '100%',
      left: '50%'
    },
    '&.bindingAnchor_right_bottom': {
      top: '100%',
      left: '100%'
    },
    '&.contentAnchor_left_top': {
      transform: 'translate(0, 0)'
    },
    '&.contentAnchor_center_top': {
      transform: 'translate(-50%, 0)'
    },
    '&.contentAnchor_right_top': {
      transform: 'translate(-100%, 0)'
    },
    '&.contentAnchor_left_center': {
      transform: 'translate(0, -50%)'
    },
    '&.contentAnchor_right_center': {
      transform: 'translate(-100%, -50%)'
    },
    '&.contentAnchor_left_bottom': {
      transform: 'translate(0, -100%)'
    },
    '&.contentAnchor_center_bottom': {
      transform: 'translate(-50%, -100%)'
    },
    '&.contentAnchor_right_bottom': {
      transform: 'translate(-100%, -100%)'
    }
  }
};
exports.default = _default;